import { createContext, Dispatch } from 'react';
import { initialState } from './reducer';
import type { Action } from './actions';

export const StateContext = createContext(initialState);
export const DispatchContext = createContext<Dispatch<Action>>(() => { });
 